module.exports = __webpack_public_path__ + "img/formsPentagon.7364373e.svg";